<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12aQhE9/tc-custom/9781488030963.jpg?1720280502123" alt="This image is the cover for the book So Tough to Tame, Jackson Hole"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">So Tough to Tame, Jackson Hole
      </h1>
      <p class="bookDescription body article font2">
        <b>A disgraced career woman licks her wounds with her high school crush, a down on his luck cowboy, in this romantic comedy by a <i>USA Today</i>–bestselling author.</b><br/><br/>Charlie Allington is supposed to be on the fast track to the top—a small-town girl who was making it big in her career. Instead, she’s reeling from a scandal that’s pretty much burned all her bridges. Now, out of options, she needs a place to lick her wounds and figure out her future. True, working at a ski resort in rugged Jackson Hole, Wyoming, isn’t her dream job. But if there’s one perk to coming back, it’s a certain sexy hometown boy who knows how to make a girl feel welcome.<br/><br/>Cowboy Walker Pearce never expected a grown-up Charlie to be temptation in tight jeans. She’s smart and successful—way out of league for a man like him. But he’s not about to let that, or his secrets, get in the way of their blazing-hot attraction. Yet when passion turns to something more, will the truth—about both of them—send her out of his life for good . . . or into his arms forever?<br/><br/><i>Previously published in 2013.</i><br/><br/><b>Praise for <i>So Tough to Tame</i></b><br/><br/><b>“I loved this book. . . . It’s a sexy, funny, emotional romp. . . . It’s also really smart, and, without being preachy or obvious, makes the reader ponder gender inequality in a way I haven’t seen in romance before. . . . A comfort read with a dose of sass and smarts; it’s just about perfect.” —Smart Bitches, Trashy Books (A+ review)</b><br/><br/><b>“Dahl delivers another sexy story while delving into weighty subjects, making this story deeper and more satisfying than the previous ones. It will delight her fans and attract new readers.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Victoria Dahl
      </h2>
      
      <p class="authorDescription body article">Victoria Dahl lives with her family in a small town high in the mountains. Her first novel debuted in 2007, and she&rsquo;s gone on to write seventeen books and novellas in historical, contemporary, and paranormal romance. Victoria's contemporary romance, Talk Me Down, was nominated for both a RWA Rita Award and the National Readers' Choice Award. Since then, her books have been nominated for two more Rita Awards, and she hit the USA Today Bestseller list with the anthology Midnight Kiss.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b4e5a4ea